import { render, staticRenderFns } from "./psp-requets.vue?vue&type=template&id=c5328e62"
import script from "./psp-requets.vue?vue&type=script&lang=js"
export * from "./psp-requets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports